import gql from 'graphql-tag';

const getYachtForSaleContactDataQuery = queryName => gql`
  query getContactData($id: String!) {
    data: getPublishedYachtForSale(id: $id) {
      businessContactComponentContacts {
        brokerBranchId
        brokerId
        brokerName
        businessContactId
        exhibitorId
        image {
          url
          data
          name
        }
        internalUrl
        name
        phone
        website
        isSponsored
        listingState
      }
      name
      yachtForSaleId: id
      price
      formattedPrice
      currency {
        code
      }
      publishedBrokers {
        name
      }
      length_overall
      built_on_year
      formattedState
      category {
        name
      }
      image {
        url
        filename
      }
      publishedExhibitors {
        name
      }
      publishedBuilderProfiles {
        name
      }
      brokerListingLinks {
        url
        brokerId
      }
      brokerIds
    }
  }
`;

export default getYachtForSaleContactDataQuery;
